<template>
  <ReleaseComponent :releaseid="this.$route.params.releaseid" />
</template>

<script>
import ReleaseComponent from "@/sections/voiceplus/components/ReleaseComponent.vue";
import config from "@/config";

export default {
  name: "Release",
  components: { ReleaseComponent },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>

<style scoped>
.home {
  background-color: #ececec;
}
</style>
